import { motion } from "framer-motion";

export default function ScoreRing({
  value = 0,
  label = "Score",
  size = 160,
  stroke = 12,
  color = "hsl(var(--primary))",
  testId,
}) {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const clipped = Math.max(0, Math.min(100, value));
  const offset = circumference - (clipped / 100) * circumference;

  return (
    <div
      className="flex flex-col items-center"
      data-testid={testId || `score-ring-${label.toLowerCase()}`}
    >
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="hsl(var(--muted))"
            strokeWidth={stroke}
            fill="none"
          />
          <motion.circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth={stroke}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            initial={{ strokeDashoffset: circumference }}
            animate={{ strokeDashoffset: offset }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span
            className="font-display text-4xl font-semibold tracking-tighter tabular-nums"
            data-testid={`${testId || label.toLowerCase()}-value`}
          >
            {clipped}
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">
            / 100
          </span>
        </div>
      </div>
      <p className="mt-3 text-sm font-medium text-foreground/90">{label}</p>
    </div>
  );
}
